import { combineReducers } from 'redux'
import * as actionTypes from '../actions/actionTypes'

const snackbarInitialState = {
  open: false,
  message: '',
  autoHideDuration: 4000
}
const snackbarReducer = (state = snackbarInitialState, {type, payload}) => {
  switch (type) {
    case actionTypes.SHOW_SNACKBAR:
      return Object.assign({}, state, {
        open: true,
        message: payload.message,
        autoHideDuration: payload.autoHideDuration
      })
    case actionTypes.HIDE_SNACKBAR:
      return Object.assign({}, state, snackbarInitialState)
    default:
      return state
  }
}

export const uiReducer = combineReducers({
  snackbar: snackbarReducer
})



/** WEBPACK FOOTER **
 ** ./src/reducers/uiReducers.js
 **/